<app-background-animation></app-background-animation>
<div class="accept-invite-container">
    <div class="invite-card">
        <mat-card>
            <mat-card-header>
                <div class="rotating-logo"></div>
                <h1>MedicAI</h1>
            </mat-card-header>
            <mat-card-content>
                <div>
                    <h2>Reject Group Invite</h2>
                    <p>Are you sure you want to reject this group invite?</p>
                    <button mat-raised-button color="secondary" (click)="cancel()">No</button>
                    <button mat-raised-button color="primary" (click)="rejectInvite()">Yes</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>